module.exports = __webpack_public_path__ + "static/media/top-title-china.74cdf852.png";